module.exports = __webpack_public_path__ + "static/media/arrow-right-red.73a62289.svg";